import { render, staticRenderFns } from "./QueueView.vue?vue&type=template&id=be66c15a&scoped=true"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"
import style0 from "./QueueView.vue?vue&type=style&index=0&id=be66c15a&prod&lang=scss&scoped=true"
import style1 from "./QueueView.vue?vue&type=style&index=1&id=be66c15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be66c15a",
  null
  
)

export default component.exports